import * as React from "react";

interface IUsersRouterProps {}

export const UsersRouter: React.FC<IUsersRouterProps> = (props) => {
	const [users, setUsers] = React.useState([]);

	return <div>Users</div>;
};
